// extracted by mini-css-extract-plugin
module.exports =  {"footerPanel":"se_jqz84TLi6HNqjowe5"};